import axios from './../http'

function get() {
    return axios.get('/captcha/get');
}

export default {
    get
}